// Components==============
import { motion } from 'framer-motion';
import React from 'react';
// =========================

const Cars = React.memo(() => (
    <>
        <motion.g
            id="BlueVanTop"
            initial={{ x: 0, y: 0 }}
            animate={{
                x: [-10, 70, 0],
                y: [-5, 35, 0],
            }}
            transition={{
                duration: 5,
                repeat: Infinity,
                repeatType: 'reverse',
                repeatDelay: Math.floor(Math.random() * 3 + 1),
            }}
        >
            <path
                d="m2078.1,2076.71c-.02.06-.03.13-.06.19.03-.06.04-.12.06-.19Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2088.41,2082.09c0,.13-.01.25-.03.35.02-.11.03-.23.03-.35Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2077.98,2077s-.05.09-.08.13c.03-.04.06-.08.08-.13Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2078.17,2076.25c0,.13-.01.25-.03.35.02-.11.03-.23.03-.35Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2078.16,2076.07s0-.04,0-.06c0-.05,0-.09-.02-.14,0,0,0,0,0,0h0c.02.13.03.25.03.38,0-.06,0-.12,0-.18Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2088.4,2081.91s0-.04,0-.06c0-.03,0-.05,0-.08h0c.01.1.03.21.03.31,0-.06,0-.12,0-.18Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2088.34,2082.54c-.02.07-.04.14-.06.2.03-.06.04-.13.06-.2Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2088.22,2082.83s-.05.1-.09.13c.03-.04.06-.09.09-.13Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2078.14,2075.88s.01.09.02.14c0,.02,0,.04,0,.06,0,.06,0,.12,0,.18,0,.13-.01.25-.03.35,0,.04-.02.07-.03.11-.02.06-.03.13-.06.19-.02.04-.04.07-.06.1-.03.04-.05.09-.08.13-.02.03-.06.04-.08.07-.04.03-.07.07-.11.09l1.13-.64c.09-.06.17-.14.24-.23l-.93-.54s0,0,0,0Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m2088.4,2081.85s0,.04,0,.06c0,.06,0,.12,0,.18,0,.13-.01.25-.03.35,0,.04-.02.06-.03.1-.02.07-.04.14-.06.2-.02.04-.04.06-.06.1-.03.05-.05.1-.09.13-.03.03-.06.05-.08.07-.04.03-.07.07-.11.09l1.13-.64c.08-.05.15-.11.21-.19l-.9-.52s0,.05,0,.08Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m2090.1,2078.81l-1.51-5.73-.03-.48s0,0-.01,0l-14.04-8.08c-.08-.04-.12-.11-.17-.17l-.36,5.18v3.95l1,.57c.15-.77.8-1.04,1.59-.59.78.45,1.43,1.47,1.58,2.41h0s.93.54.93.54l6.14,3.53c.13-.81.79-1.11,1.59-.64.8.46,1.46,1.52,1.58,2.47h0s.9.52.9.52l.82.47v-3.95Z"
                fill="#4262ea"
                strokeWidth="0"
            />
            <path
                d="m2077.89,2077.13s.06-.08.08-.13c.02-.03.05-.06.06-.1.03-.06.04-.12.06-.19.01-.04.03-.07.03-.11.02-.11.03-.23.03-.35,0-.12-.01-.25-.03-.38-.14-.94-.79-1.95-1.58-2.41-.79-.45-1.44-.19-1.59.59-.02.1-.03.22-.03.34,0,1.02.72,2.27,1.61,2.79.51.3.96.28,1.26.02.03-.02.06-.04.08-.07Z"
                strokeWidth="0"
            />
            <path
                d="m2088.13,2082.96s.06-.09.09-.13c.02-.03.04-.06.06-.1.03-.06.04-.13.06-.2,0-.03.02-.06.03-.1.02-.11.03-.23.03-.35,0-.1-.01-.21-.03-.31-.12-.95-.78-2.01-1.58-2.47-.8-.46-1.47-.17-1.59.64-.01.09-.03.18-.03.28,0,1.02.72,2.27,1.61,2.79.51.29.96.28,1.26.02.03-.02.06-.04.08-.07Z"
                strokeWidth="0"
            />
            <path
                d="m2096.57,2069.12c-.06.1-.14.19-.25.25l-5.56,3.23c-.68.39-1.51.39-2.2,0l.03.48,1.51,5.73v3.95l7.83-4.51h0v-3.42h0v-.54l-1.36-5.18Z"
                fill="#6181e2"
                strokeWidth="0"
            />
            <path
                d="m2088.55,2072.6s0,0,.01,0c.68.39,1.52.39,2.2,0l5.56-3.23c.11-.06.19-.16.25-.25.24-.36.17-.87-.25-1.11l-14.3-7.91c-.68-.39-1.52-.39-2.21,0l-5.31,3.05c-.45.26-.49.84-.17,1.19.05.06.09.13.17.17l14.04,8.08Zm-10.23-10.95l2.1-1.21c.27-.16.6-.16.87,0l7.59,4.24c.21.12.21.42,0,.54l-2.2,1.28c-.27.16-.6.16-.87,0l-7.49-4.3c-.21-.12-.21-.42,0-.54Z"
                fill="#fff"
                strokeWidth="0"
            />
            <path
                d="m2085.81,2066.49c.27.16.6.16.87,0l2.2-1.28c.21-.12.21-.42,0-.54l-7.59-4.24c-.27-.16-.6-.16-.87,0l-2.1,1.21c-.21.12-.21.42,0,.54l7.49,4.3Z"
                fill="#ddc7c0"
                strokeWidth="0"
            />
        </motion.g>
        <motion.g
            id="GreenVanTop"
            initial={{ x: 0, y: 0 }}
            animate={{
                x: [10, -15, 0],
                y: [5, -7.5, 0],
            }}
            transition={{
                duration: 2,
                repeat: Infinity,
                repeatType: 'reverse',
                repeatDelay: Math.floor(Math.random() * 3 + 1),
            }}
        >
            <path
                d="m2378,2246.41c-.02.06-.03.13-.06.19.03-.06.04-.12.06-.19Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2388.31,2251.78c0,.13-.01.25-.03.35.02-.11.03-.23.03-.35Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2377.87,2246.7s-.05.09-.08.13c.03-.04.06-.08.08-.13Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2378.06,2245.95c0,.13-.01.25-.03.35.02-.11.03-.23.03-.35Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2378.06,2245.77s0-.04,0-.06c0-.05,0-.09-.02-.14,0,0,0,0,0,0h0c.02.13.03.25.03.38,0-.06,0-.12,0-.18Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2388.3,2251.6s0-.04,0-.06c0-.03,0-.05,0-.08h0c.01.1.03.21.03.31,0-.06,0-.12,0-.18Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2388.24,2252.23c-.02.07-.04.14-.06.2.03-.06.04-.13.06-.2Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2388.12,2252.52s-.05.1-.09.13c.03-.04.06-.09.09-.13Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2378.03,2245.57s.01.09.02.14c0,.02,0,.04,0,.06,0,.06,0,.12,0,.18,0,.13-.01.25-.03.35,0,.04-.02.07-.03.11-.02.06-.03.13-.06.19-.02.04-.04.07-.06.1-.03.04-.05.09-.08.13-.02.03-.06.04-.08.07-.04.03-.07.07-.11.09l1.13-.64c.09-.06.17-.14.24-.23l-.93-.54s0,0,0,0Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m2388.29,2251.55s0,.04,0,.06c0,.06,0,.12,0,.18,0,.13-.01.25-.03.35,0,.04-.02.06-.03.1-.02.07-.04.14-.06.2-.02.04-.04.06-.06.1-.03.05-.05.1-.09.13-.03.03-.06.05-.08.07-.04.03-.07.07-.11.09l1.13-.64c.08-.05.15-.11.21-.19l-.9-.52s0,.05,0,.08Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m2390,2248.5l-1.51-5.73-.03-.48s0,0-.01,0l-14.04-8.08c-.08-.04-.12-.11-.17-.17l-.36,5.18v3.95l1,.57c.15-.77.8-1.04,1.59-.59.78.45,1.43,1.47,1.58,2.41h0s.93.54.93.54l6.14,3.53c.13-.81.79-1.11,1.59-.64.8.46,1.46,1.52,1.58,2.47h0s.9.52.9.52l.82.47v-3.95Z"
                fill="#16d872"
                strokeWidth="0"
            />
            <path
                d="m2377.79,2246.82s.06-.08.08-.13c.02-.03.05-.06.06-.1.03-.06.04-.12.06-.19.01-.04.03-.07.03-.11.02-.11.03-.23.03-.35,0-.12-.01-.25-.03-.38-.14-.94-.79-1.95-1.58-2.41-.79-.45-1.44-.19-1.59.59-.02.1-.03.22-.03.34,0,1.02.72,2.27,1.61,2.79.51.3.96.28,1.26.02.03-.02.06-.04.08-.07Z"
                strokeWidth="0"
            />
            <path
                d="m2388.03,2252.66s.06-.09.09-.13c.02-.03.04-.06.06-.1.03-.06.04-.13.06-.2,0-.03.02-.06.03-.1.02-.11.03-.23.03-.35,0-.1-.01-.21-.03-.31-.12-.95-.78-2.01-1.58-2.47-.8-.46-1.47-.17-1.59.64-.01.09-.03.18-.03.28,0,1.02.72,2.27,1.61,2.79.51.29.96.28,1.26.02.03-.02.06-.04.08-.07Z"
                strokeWidth="0"
            />
            <path
                d="m2396.47,2238.81c-.06.1-.14.19-.25.25l-5.56,3.23c-.68.39-1.51.39-2.2,0l.03.48,1.51,5.73v3.95l7.83-4.51h0v-3.42h0v-.54l-1.36-5.18Z"
                fill="#28e57d"
                strokeWidth="0"
            />
            <path
                d="m2388.45,2242.29s0,0,.01,0c.68.39,1.52.39,2.2,0l5.56-3.23c.11-.06.19-.16.25-.25.24-.36.17-.87-.25-1.11l-14.3-7.91c-.68-.39-1.52-.39-2.21,0l-5.31,3.05c-.45.26-.49.84-.17,1.19.05.06.09.13.17.17l14.04,8.08Zm-10.23-10.95l2.1-1.21c.27-.16.6-.16.87,0l7.59,4.24c.21.12.21.42,0,.54l-2.2,1.28c-.27.16-.6.16-.87,0l-7.49-4.3c-.21-.12-.21-.42,0-.54Z"
                fill="#fff"
                strokeWidth="0"
            />
            <path
                d="m2385.7,2236.19c.27.16.6.16.87,0l2.2-1.28c.21-.12.21-.42,0-.54l-7.59-4.24c-.27-.16-.6-.16-.87,0l-2.1,1.21c-.21.12-.21.42,0,.54l7.49,4.3Z"
                fill="#ddc7c0"
                strokeWidth="0"
            />
        </motion.g>
        <motion.g
            id="BlueCarTop"
            initial={{ x: 0, y: 0 }}
            animate={{
                x: [-10, 20, 0],
                y: [-5, 10, 0],
            }}
            transition={{
                duration: 5,
                repeat: Infinity,
                repeatType: 'reverse',
                repeatDelay: Math.floor(Math.random() * 3 + 1),
            }}
        >
            <path
                d="m2043.72,2067.77c0,.14-.03.26-.07.36.05-.1.07-.22.07-.36Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2038.01,2064.42s0-.02,0-.03c0-.03,0-.05,0-.08h0s-.02-.01-.02-.01c.01.07.03.15.03.22,0-.03,0-.07,0-.1Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2043.72,2067.67s0-.02,0-.03c0-.01,0-.03,0-.04h-.02c0,.05.03.11.03.17,0-.03,0-.07,0-.1Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2038.01,2064.52c0,.14-.03.26-.07.36.05-.1.07-.22.07-.36Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2038,2064.31s0,.05,0,.08c0,.01,0,.02,0,.03,0,.03,0,.07,0,.1,0,.14-.03.26-.07.36-.01.03-.04.04-.06.07-.04.05-.07.11-.13.15l.63-.36c.05-.03.08-.09.12-.14l-.51-.29h0Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m2043.72,2067.64s0,.02,0,.03c0,.03,0,.07,0,.1,0,.14-.03.26-.07.36-.01.03-.04.04-.06.07-.04.06-.08.12-.13.15l.63-.36s.07-.08.1-.11l-.48-.28s0,.03,0,.04Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m2044.67,2066.24v-.3l-2.71-2.74-.69-3.35-3.72-1.56-1.89,2.47v2.2l.57.33c.08-.42.43-.59.87-.34.43.25.78.81.86,1.33h.02s.51.3.51.3l3.45,1.99c.07-.45.43-.63.87-.37.45.26.8.84.87,1.37h.02s.48.29.48.29l.47.27,4.37-2.51-4.37,2.51v-1.9Z"
                fill="#4262ea"
                strokeWidth="0"
            />
            <path
                d="m2038.01,2064.52c0-.07-.02-.15-.03-.22-.08-.52-.43-1.08-.86-1.33-.44-.25-.78-.09-.87.34-.01.06-.04.11-.04.18,0,.57.4,1.27.9,1.55.33.19.61.14.77-.08.02-.03.05-.04.06-.07.05-.1.07-.22.07-.36Z"
                strokeWidth="0"
            />
            <path
                d="m2043.72,2067.77c0-.06-.02-.12-.03-.18-.07-.53-.42-1.11-.87-1.37-.45-.26-.8-.08-.87.37,0,.05-.03.09-.03.15,0,.57.4,1.27.9,1.55.33.19.61.14.77-.09.02-.03.05-.04.06-.07.05-.1.07-.22.07-.36Z"
                strokeWidth="0"
            />
            <polygon
                points="2045.91 2060.96 2045.35 2058.04 2041.06 2056.74 2037.56 2058.3 2041.28 2059.86 2041.96 2063.21 2044.67 2065.94 2044.67 2066.24 2044.67 2068.15 2049.03 2065.64 2049.03 2063.73 2049.03 2063.43 2045.91 2060.96"
                fill="#6181e2"
                strokeWidth="0"
            />
        </motion.g>
        <motion.g
            id="RedCarTop"
            initial={{ x: 0, y: 0 }}
            animate={{
                x: [10, -10, 0],
                y: [5, -5, 0],
            }}
            transition={{
                duration: 3,
                repeat: Infinity,
                repeatType: 'reverse',
                repeatDelay: Math.floor(Math.random() * 3 + 1),
            }}
        >
            <path
                d="m2013.04,2037.48s0-.02,0-.03c0-.03,0-.05,0-.08,0,0,0,0,0,0h-.02c.01.06.03.14.03.21,0-.03,0-.07,0-.1Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2018.75,2040.73s0-.02,0-.03c0-.01,0-.03,0-.04h-.02c0,.05.03.11.03.17,0-.03,0-.07,0-.1Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2018.76,2040.83c0,.14-.03.26-.07.36.05-.1.07-.22.07-.36Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2013.05,2037.58c0,.14-.03.26-.07.36.05-.1.07-.22.07-.36Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2013.03,2037.37s0,.05,0,.08c0,.01,0,.02,0,.03,0,.03,0,.07,0,.1,0,.14-.03.26-.07.36-.01.03-.04.04-.06.07-.04.05-.07.11-.13.15l.63-.36c.05-.03.08-.09.12-.14l-.51-.29s0,0,0,0Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m2018.75,2040.7s0,.02,0,.03c0,.03,0,.07,0,.1,0,.14-.03.26-.07.36-.01.03-.04.04-.06.07-.04.05-.07.11-.13.15l.63-.36s.07-.08.1-.11l-.48-.28s0,.03,0,.04Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m2019.7,2039l-2.71-2.74-.69-3.35-3.72-1.56-1.89,2.47v2.2l.57.33c.08-.42.43-.59.87-.34.43.25.78.81.86,1.33h.02s.51.3.51.3l3.45,1.99c.07-.45.43-.63.87-.37.45.26.8.84.87,1.37h.02s.48.29.48.29l.47.27v-2.2Z"
                fill="#c7302d"
                strokeWidth="0"
            />
            <polygon
                points="2019.7 2041.21 2024.07 2038.7 2019.7 2041.21 2019.7 2041.21"
                fill="#c7302d"
                strokeWidth="0"
            />
            <path
                d="m2013.05,2037.58c0-.07-.02-.15-.03-.22-.08-.52-.43-1.08-.86-1.33-.44-.25-.78-.09-.87.34-.01.06-.04.11-.04.18,0,.57.4,1.27.9,1.55.33.19.61.14.77-.08.02-.03.05-.04.06-.07.05-.1.07-.22.07-.36Z"
                strokeWidth="0"
            />
            <path
                d="m2018.76,2040.83c0-.06-.02-.12-.03-.18-.07-.53-.42-1.11-.87-1.37-.45-.26-.8-.08-.87.37,0,.05-.03.09-.03.15,0,.57.4,1.27.9,1.55.33.19.61.14.77-.08.02-.03.05-.04.06-.07.05-.1.07-.22.07-.36Z"
                strokeWidth="0"
            />
            <polygon
                points="2020.95 2034.02 2020.38 2031.1 2016.31 2032.92 2016.99 2036.27 2019.7 2039 2019.7 2039.3 2019.7 2041.21 2019.7 2041.21 2019.7 2041.21 2024.07 2038.7 2024.07 2036.79 2024.07 2036.79 2024.07 2036.49 2020.95 2034.02"
                fill="#f44e4e"
                strokeWidth="0"
            />
            <polygon
                points="2020.38 2031.1 2016.09 2029.8 2012.59 2031.36 2016.31 2032.92 2020.38 2031.1"
                fill="#dd3a3a"
                strokeWidth="0"
            />
        </motion.g>

        <motion.g
            id="YellowCarTop"
            initial={{ x: 0, y: 0 }}
            animate={{
                x: [-8, 15, 0],
                y: [-4, 7.5, 0],
            }}
            transition={{
                duration: 3,
                repeat: Infinity,
                repeatType: 'reverse',
                repeatDelay: Math.floor(Math.random() * 3 + 1),
            }}
        >
            <path
                d="m2251.35,2172.31c0,.14-.03.26-.07.36.05-.1.07-.22.07-.36Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2243.5,2168.28c0,.14-.03.26-.07.36.05-.1.07-.22.07-.36Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2251.35,2172.21s0-.02,0-.03c0-.01,0-.03,0-.04h-.02c0,.05.03.11.03.17,0-.03,0-.07,0-.1Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2243.5,2168.18s0-.02,0-.03c0-.03,0-.05,0-.08,0,0,0-.01,0-.02,0,0,0-.01,0-.02h-.02c.02.08.04.16.04.24,0-.03,0-.07,0-.1Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m2243.48,2168.06s0,.01,0,.02c0,.03,0,.05,0,.08,0,.01,0,.02,0,.03,0,.03,0,.07,0,.1,0,.14-.03.26-.07.36-.01.03-.04.04-.06.07-.04.05-.07.11-.13.15l.63-.36c.07-.04.12-.11.16-.18l-.55-.28s0,.01,0,.02Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m2251.35,2172.18s0,.02,0,.03c0,.03,0,.07,0,.1,0,.14-.03.26-.07.36-.02.03-.05.05-.06.07-.04.05-.07.11-.13.14l.63-.36s.07-.08.1-.11l-.48-.28s0,.03,0,.04Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m2252.3,2170.48l-2.71-2.74-2.57-4.1-5.86-2.34v5.43l.57.33c.08-.42.43-.59.87-.34.43.25.77.79.86,1.3h.02s.55.29.55.29l5.55,2.83c.06-.47.42-.65.88-.39.45.26.8.84.87,1.37h.02s.48.29.48.29l.47.27v-2.2Z"
                fill="#eacf5e"
                strokeWidth="0"
            />
            <path
                d="m2243.5,2168.28c0-.08-.02-.17-.04-.25-.09-.51-.43-1.06-.86-1.3-.44-.25-.78-.09-.87.34-.01.06-.04.11-.04.18,0,.57.4,1.27.9,1.55.33.19.61.14.77-.08.02-.03.05-.04.06-.07.05-.1.07-.22.07-.36Z"
                strokeWidth="0"
            />
            <path
                d="m2251.35,2172.31c0-.06-.02-.12-.03-.18-.07-.53-.42-1.11-.87-1.37-.45-.26-.82-.08-.88.39,0,.04-.02.07-.02.12,0,.57.4,1.27.9,1.55.33.19.61.14.77-.08.02-.03.05-.04.06-.07.05-.1.07-.22.07-.36Z"
                strokeWidth="0"
            />
            <polygon
                points="2253.54 2165.5 2251.1 2161.83 2247.02 2163.65 2249.59 2167.75 2252.3 2170.48 2252.3 2170.78 2252.3 2172.69 2256.66 2170.18 2256.66 2168.27 2256.66 2168.27 2256.66 2167.97 2253.54 2165.5"
                fill="#f5df61"
                strokeWidth="0"
            />
            <polygon
                points="2251.1 2161.83 2244.66 2159.75 2241.16 2161.31 2247.02 2163.65 2251.1 2161.83"
                fill="#d8b72b"
                strokeWidth="0"
            />
        </motion.g>
        {/* Cars bottom */}

        <motion.g
            initial={{ x: 0, y: 0 }}
            animate={{
                x: [-80, 0],
                y: [45, 0],
            }}
            transition={{
                duration: 4,
                repeat: Infinity,
                repeatType: 'reverse',
                repeatDelay: Math.floor(Math.random() * 3 + 1),
            }}
            id="BlueVanBottom"
        >
            <path
                d="m5531,3407.18c.02.06.03.13.06.19-.03-.06-.04-.12-.06-.19Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5520.69,3412.55c0,.13.01.25.03.35-.02-.11-.03-.23-.03-.35Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5531.13,3407.47s.05.09.08.13c-.03-.04-.06-.08-.08-.13Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5530.93,3406.72c0,.13.01.25.03.35-.02-.11-.03-.23-.03-.35Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5530.94,3406.54s0-.04,0-.06c0-.05,0-.09.02-.14,0,0,0,0,0,0h0c-.02.13-.03.25-.03.38,0-.06,0-.12,0-.18Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5520.7,3412.37s0-.04,0-.06c0-.03,0-.05,0-.08h0c-.01.1-.03.21-.03.31,0-.06,0-.12,0-.18Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5520.76,3413c.02.07.04.14.06.2-.03-.06-.04-.13-.06-.2Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5520.88,3413.29s.05.1.09.13c-.03-.04-.06-.09-.09-.13Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5530.96,3406.34s-.01.09-.02.14c0,.02,0,.04,0,.06,0,.06,0,.12,0,.18,0,.13.01.25.03.35,0,.04.02.07.03.11.02.06.03.13.06.19.02.04.04.07.06.1.03.04.05.09.08.13.02.03.06.04.08.07.04.03.07.07.11.09l-1.13-.64c-.09-.06-.17-.14-.24-.23l.93-.54s0,0,0,0Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m5520.71,3412.31s0,.04,0,.06c0,.06,0,.12,0,.18,0,.13.01.25.03.35,0,.04.02.06.03.1.02.07.04.14.06.2.02.04.04.06.06.1.03.05.05.1.09.13.03.03.06.05.08.07.04.03.07.07.11.09l-1.13-.64c-.08-.05-.15-.11-.21-.19l.9-.52s0,.05,0,.08Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m5519,3409.27l1.51-5.73.03-.48s0,0,.01,0l14.04-8.08c.08-.04.12-.11.17-.17l.36,5.18v.54s0,1.34,0,1.34v.74s0,1.34,0,1.34l-1,.57c-.15-.77-.8-1.04-1.59-.59-.78.45-1.43,1.47-1.58,2.41h0s-.93.54-.93.54l-6.14,3.53c-.13-.81-.79-1.11-1.59-.64-.8.46-1.46,1.52-1.58,2.47h0s-.9.52-.9.52l-.82.47v-3.42s0-.54,0-.54Z"
                fill="#4262ea"
                strokeWidth="0"
            />
            <path
                d="m5531.21,3407.59s-.06-.08-.08-.13c-.02-.03-.05-.06-.06-.1-.03-.06-.04-.12-.06-.19-.01-.04-.03-.07-.03-.11-.02-.11-.03-.23-.03-.35,0-.12.01-.25.03-.38.14-.94.79-1.95,1.58-2.41.79-.45,1.44-.19,1.59.59.02.1.03.22.03.34,0,1.02-.72,2.27-1.61,2.79-.51.3-.96.28-1.26.02-.03-.02-.06-.04-.08-.07Z"
                strokeWidth="0"
            />
            <path
                d="m5520.97,3413.43s-.06-.09-.09-.13c-.02-.03-.04-.06-.06-.1-.03-.06-.04-.13-.06-.2,0-.03-.02-.06-.03-.1-.02-.11-.03-.23-.03-.35,0-.1.01-.21.03-.31.12-.95.78-2.01,1.58-2.47.8-.46,1.47-.17,1.59.64.01.09.03.18.03.28,0,1.02-.72,2.27-1.61,2.79-.51.29-.96.28-1.26.02-.03-.02-.06-.04-.08-.07Z"
                strokeWidth="0"
            />
            <path
                d="m5512.53,3399.58c.06.1.14.19.25.25l5.56,3.23c.68.39,1.51.39,2.2,0l-.03.48-1.51,5.73v.54s0,3.42,0,3.42l-7.83-4.51h0v-3.42s0,0,0,0v-.54s1.36-5.18,1.36-5.18Z"
                fill="#6181e2"
                strokeWidth="0"
            />
            <path
                d="m5534.59,3394.98c.08-.04.12-.11.17-.17.32-.35.28-.93-.17-1.19l-5.31-3.05c-.68-.39-1.52-.39-2.21,0l-14.3,7.91c-.42.24-.49.75-.25,1.11.06.1.14.19.25.25l5.56,3.23c.68.39,1.51.39,2.2,0,0,0,0,0,.01,0l14.04-8.08Zm-3.81-2.32l-7.49,4.3c-.27.16-.6.16-.87,0l-2.2-1.28c-.21-.12-.21-.42,0-.54l7.59-4.24c.27-.16.6-.16.87,0l2.1,1.21c.21.12.21.42,0,.54Z"
                fill="#fff"
                strokeWidth="0"
            />
            <path
                d="m5523.29,3396.96c-.27.16-.6.16-.87,0l-2.2-1.28c-.21-.12-.21-.42,0-.54l7.59-4.24c.27-.16.6-.16.87,0l2.1,1.21c.21.12.21.42,0,.54l-7.49,4.3Z"
                fill="#ddc7c0"
                strokeWidth="0"
            />
        </motion.g>
        <motion.g
            initial={{ x: 0, y: 0 }}
            animate={{
                x: [30, 0],
                y: [-15, 0],
            }}
            transition={{
                duration: 2,
                repeat: Infinity,
                repeatType: 'reverse',
                repeatDelay: Math.floor(Math.random() * 3 + 1),
            }}
            id="BlueCarBottom"
        >
            <path
                d="m5574.78,3386.43s0,.07,0,.1c0-.06.02-.12.03-.18h-.02s0,.04,0,.05c0,.01,0,.02,0,.03Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5580.49,3383.15s0,.02,0,.03c0,.03,0,.07,0,.1,0-.07.02-.15.03-.22h-.02s0,.01,0,.01c0,.03,0,.05,0,.08Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5574.77,3386.53c0,.14.03.26.07.36-.05-.1-.07-.22-.07-.36Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5580.48,3383.28c0,.14.03.26.07.36-.05-.1-.07-.22-.07-.36Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5580.48,3383.28s0-.07,0-.1c0-.01,0-.02,0-.03,0-.03,0-.05,0-.08,0,0,0,0,0,0l-.51.29s.07.11.12.14l.63.36c-.05-.03-.09-.09-.13-.14-.02-.03-.05-.04-.07-.07-.05-.1-.07-.22-.07-.36Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m5574.77,3386.53s0-.07,0-.1c0-.01,0-.02,0-.03,0-.01,0-.03,0-.04l-.48.28s.06.09.1.11l.63.36c-.05-.03-.09-.09-.13-.14-.02-.03-.05-.04-.06-.07-.05-.1-.07-.22-.07-.36Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m5582.82,3379.53l-1.89-2.47-3.72,1.56-.69,3.35-2.71,2.74v2.2l.47-.27.48-.28h.02c.07-.54.42-1.12.87-1.38.45-.26.8-.08.87.37l3.45-1.99.51-.29h.02c.08-.53.43-1.09.86-1.34.44-.25.78-.09.87.34l.57-.33v-2.2Z"
                fill="#4262ea"
                strokeWidth="0"
            />
            <path
                d="m5581.38,3381.72c-.43.25-.78.81-.86,1.33-.01.07-.03.15-.03.22,0,.14.03.26.07.36.02.03.05.05.07.07.16.22.43.27.77.08.5-.29.9-.98.9-1.55,0-.07-.02-.12-.04-.18-.08-.42-.43-.59-.87-.34Z"
                strokeWidth="0"
            />
            <path
                d="m5575.67,3384.98c-.45.26-.8.84-.87,1.37,0,.06-.03.12-.03.18,0,.14.03.26.07.36.02.03.04.05.06.07.16.22.44.27.77.08.5-.29.9-.98.9-1.55,0-.06-.02-.1-.03-.15-.07-.45-.43-.63-.87-.37Z"
                strokeWidth="0"
            />
            <polygon
                points="5573.83 3384.7 5576.53 3381.96 5577.22 3378.62 5580.93 3377.06 5577.44 3375.49 5573.14 3376.79 5572.58 3379.72 5569.46 3382.19 5569.46 3382.49 5569.46 3382.49 5569.46 3384.39 5573.83 3386.91 5573.83 3385 5573.83 3384.7"
                fill="#6181e2"
                strokeWidth="0"
            />
        </motion.g>
        <motion.g
            initial={{ x: 0, y: 0 }}
            animate={{
                x: [10, -15, 0],
                y: [-5, 7.5, 0],
            }}
            transition={{
                duration: 2,
                repeat: Infinity,
                repeatType: 'reverse',
                repeatDelay: Math.floor(Math.random() * 3 + 1),
            }}
            id="RedCarBottom"
        >
            <path
                d="m5605.46,3356.21s0,.02,0,.03c0,.03,0,.07,0,.1,0-.07.02-.15.03-.22h-.02s0,.01,0,.01c0,.03,0,.05,0,.08Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5599.74,3359.49s0,.07,0,.1c0-.06.02-.12.03-.18h-.02s0,.04,0,.05c0,.01,0,.02,0,.03Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5605.45,3356.34c0,.14.03.26.07.36-.05-.1-.07-.22-.07-.36Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5599.74,3359.59c0,.14.03.26.07.36-.05-.1-.07-.22-.07-.36Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5605.45,3356.34s0-.07,0-.1c0-.01,0-.02,0-.03,0-.03,0-.05,0-.08,0,0,0,0,0,0l-.51.29s.07.11.12.14l.63.36c-.05-.03-.09-.09-.13-.14-.02-.03-.05-.04-.06-.07-.05-.1-.07-.22-.07-.36Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m5599.74,3359.59s0-.07,0-.1c0-.01,0-.02,0-.03,0-.01,0-.03,0-.04l-.48.28s.06.09.1.11l.63.36c-.05-.03-.09-.09-.13-.15-.02-.03-.05-.04-.06-.07-.05-.1-.07-.22-.07-.36Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m5607.79,3352.59l-1.89-2.47-3.72,1.56-.69,3.35-2.71,2.74v2.2l-4.37-2.51,4.37,2.51.47-.27.48-.28h.02c.07-.54.42-1.12.87-1.38.45-.26.8-.08.87.37l3.45-1.99.51-.29h.02c.08-.53.43-1.09.86-1.34.44-.25.78-.09.87.34l.57-.33v-2.2Z"
                fill="#c7302d"
                strokeWidth="0"
            />
            <path
                d="m5606.35,3354.78c-.43.25-.78.81-.86,1.33-.01.07-.03.15-.03.22,0,.14.03.26.07.36.02.03.04.05.06.07.16.22.44.27.77.08.5-.29.9-.98.9-1.55,0-.07-.02-.12-.04-.18-.08-.42-.43-.59-.87-.34Z"
                strokeWidth="0"
            />
            <path
                d="m5600.64,3358.04c-.45.26-.8.84-.87,1.37,0,.06-.03.12-.03.18,0,.14.03.26.07.36.01.03.04.04.06.07.16.22.44.28.77.08.5-.29.9-.98.9-1.55,0-.06-.02-.1-.03-.15-.07-.45-.43-.63-.87-.37Z"
                strokeWidth="0"
            />
            <polygon
                points="5598.8 3358.06 5598.8 3357.76 5601.5 3355.02 5602.19 3351.68 5598.11 3349.85 5597.55 3352.78 5594.43 3355.25 5594.43 3355.55 5594.43 3357.45 5598.8 3359.97 5598.8 3358.06"
                fill="#f44e4e"
                strokeWidth="0"
            />
            <polygon
                points="5605.9 3350.12 5602.4 3348.55 5598.11 3349.85 5602.19 3351.68 5605.9 3350.12"
                fill="#dd3a3a"
                strokeWidth="0"
            />
        </motion.g>
        <motion.g
            animate={{
                x: [-80, 0],
                y: [45, 0],
            }}
            transition={{
                duration: 5,
                repeat: Infinity,
                repeatType: 'reverse',
                repeatDelay: Math.floor(Math.random() * 3 + 1),
            }}
            id="GreenVanBottom"
        >
            <path
                d="m5237.17,3580.92c.02.06.03.13.06.19-.03-.06-.04-.12-.06-.19Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5226.86,3586.29c0,.13.01.25.03.35-.02-.11-.03-.23-.03-.35Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5237.29,3581.21s.05.09.08.13c-.03-.04-.06-.08-.08-.13Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5237.1,3580.46c0,.13.01.25.03.35-.02-.11-.03-.23-.03-.35Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5237.11,3580.28s0-.04,0-.06c0-.05,0-.09.02-.14,0,0,0,0,0,0h0c-.02.13-.03.25-.03.38,0-.06,0-.12,0-.18Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5226.87,3586.12s0-.04,0-.06c0-.03,0-.05,0-.08h0c-.01.1-.03.21-.03.31,0-.06,0-.12,0-.18Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5226.92,3586.75c.02.07.04.14.06.2-.03-.06-.04-.13-.06-.2Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5227.05,3587.04s.05.1.09.13c-.03-.04-.06-.09-.09-.13Z"
                fill="none"
                strokeWidth="0"
            />
            <path
                d="m5237.13,3580.09s-.01.09-.02.14c0,.02,0,.04,0,.06,0,.06,0,.12,0,.18,0,.13.01.25.03.35,0,.04.02.07.03.11.02.06.03.13.06.19.02.04.04.07.06.1.03.04.05.09.08.13.02.03.06.04.08.07.04.03.07.07.11.09l-1.13-.64c-.09-.06-.17-.14-.24-.23l.93-.54s0,0,0,0Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m5226.87,3586.06s0,.04,0,.06c0,.06,0,.12,0,.18,0,.13.01.25.03.35,0,.04.02.06.03.1.02.07.04.14.06.2.02.04.04.06.06.1.03.05.05.1.09.13.03.03.06.05.08.07.04.03.07.07.11.09l-1.13-.64c-.08-.05-.15-.11-.21-.19l.9-.52s0,.05,0,.08Z"
                fill="#333"
                strokeWidth="0"
            />
            <path
                d="m5225.17,3583.02l1.51-5.73.03-.48s0,0,.01,0l14.04-8.08c.08-.04.12-.11.17-.17l.36,5.18v.54s0,1.34,0,1.34v.74s0,1.34,0,1.34l-1,.57c-.15-.77-.8-1.04-1.59-.59-.78.45-1.43,1.47-1.58,2.41h0s-.93.54-.93.54l-6.14,3.53c-.13-.81-.79-1.11-1.59-.64-.8.46-1.46,1.52-1.58,2.47h0s-.9.52-.9.52l-.82.47v-3.42s0-.54,0-.54Z"
                fill="#78e271"
                strokeWidth="0"
            />
            <path
                d="m5237.38,3581.34s-.06-.08-.08-.13c-.02-.03-.05-.06-.06-.1-.03-.06-.04-.12-.06-.19-.01-.04-.03-.07-.03-.11-.02-.11-.03-.23-.03-.35,0-.12.01-.25.03-.38.14-.94.79-1.95,1.58-2.41.79-.45,1.44-.19,1.59.59.02.1.03.22.03.34,0,1.02-.72,2.27-1.61,2.79-.51.3-.96.28-1.26.02-.03-.02-.06-.04-.08-.07Z"
                strokeWidth="0"
            />
            <path
                d="m5227.14,3587.17s-.06-.09-.09-.13c-.02-.03-.04-.06-.06-.1-.03-.06-.04-.13-.06-.2,0-.03-.02-.06-.03-.1-.02-.11-.03-.23-.03-.35,0-.1.01-.21.03-.31.12-.95.78-2.01,1.58-2.47.8-.46,1.47-.17,1.59.64.01.09.03.18.03.28,0,1.02-.72,2.27-1.61,2.79-.51.29-.96.28-1.26.02-.03-.02-.06-.04-.08-.07Z"
                strokeWidth="0"
            />
            <path
                d="m5218.7,3573.33c.06.1.14.19.25.25l5.56,3.23c.68.39,1.51.39,2.2,0l-.03.48-1.51,5.73v.54s0,3.42,0,3.42l-7.83-4.51h0v-3.42s0,0,0,0v-.54s1.36-5.18,1.36-5.18Z"
                fill="#60cf71"
                strokeWidth="0"
            />
            <path
                d="m5240.76,3568.72c.08-.04.12-.11.17-.17.32-.35.28-.93-.17-1.19l-5.31-3.05c-.68-.39-1.52-.39-2.21,0l-14.3,7.91c-.42.24-.49.75-.25,1.11.06.1.14.19.25.25l5.56,3.23c.68.39,1.51.39,2.2,0,0,0,0,0,.01,0l14.04-8.08Zm-3.81-2.32l-7.49,4.3c-.27.16-.6.16-.87,0l-2.2-1.28c-.21-.12-.21-.42,0-.54l7.59-4.24c.27-.16.6-.16.87,0l2.1,1.21c.21.12.21.42,0,.54Z"
                fill="#fff"
                strokeWidth="0"
            />
            <path
                d="m5229.46,3570.7c-.27.16-.6.16-.87,0l-2.2-1.28c-.21-.12-.21-.42,0-.54l7.59-4.24c.27-.16.6-.16.87,0l2.1,1.21c.21.12.21.42,0,.54l-7.49,4.3Z"
                fill="#ddc7c0"
                strokeWidth="0"
            />
        </motion.g>
    </>
));

Cars.displayName = 'Cars';
export default Cars;
